import QueryDatabase from "./QueryDatabase";

/**Output:
     * Recipe_Name
     * Recipe_ID
     * Plan_Date
     * Plan_ID:num, unique
     * Recipe_Ingredients:{
     * Ingredient_Name
     * Ingredient_Quantity
     * Recipe_Ingredient_ID
     * Ingredient_ID: id of item from ingredient table
     * Item_ID: id of item from shopping list table
     * }
     */
export const getPlansData = async (serverProps, userID, plans, setPlans, setServerAccess, startIndex = -6, amount = 12) => {
    setServerAccess(0);
    await QueryDatabase({
        user: userID,
        table: "recipe_plans",
        method: 2,
        filter: "",
        data: JSON.stringify({
            monthQueryStart: startIndex,
            monthQueryLength: amount
        }),
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        const newRecipePlans = [
            ...plans,
            ...data
        ];
        setPlans(newRecipePlans.map((recipePlan) => {
            const newRecipePlan = {
                ...recipePlan
            }
            if (typeof (recipePlan.Recipe_Ingredients) === "string")
                newRecipePlan.Recipe_Ingredients = JSON.parse(recipePlan.Recipe_Ingredients)
            if (typeof (recipePlan.Plan_Date) === "string")
                newRecipePlan.Plan_Date = new Date(recipePlan.Plan_Date)
                
            return newRecipePlan;
        }));
        setServerAccess(1);
    })
}

export const addRecipePlan = async (userID, serverProps, recipePlans, setRecipePlans, recipe, activeDate) => {
    const date = activeDate;
    const dateString = date.getFullYear() + "-" + (Math.floor(date.getMonth() / 10) === 0 ? "0" : "") + (date.getMonth() + 1) + "-" + (Math.floor(date.getDate() / 10) === 0 ? "0" : "") + date.getDate();
    await QueryDatabase({
        user: userID,
        table: "recipe_plans",
        method: 0,
        filter: "",
        data: {
            Recipe_ID: recipe.Recipe_ID,
            Plan_Date: dateString
        },
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        if (data) {
            const plan_id = data.insertId;
            const newRecipePlans = [...recipePlans, {
                Recipe_ID: recipe.Recipe_ID,
                Recipe_Name: recipe.Recipe_Name,
                Plan_Date: activeDate,
                Plan_ID: plan_id,
                Recipe_Ingredients: recipe.Recipe_Ingredients
            }]
            setRecipePlans(newRecipePlans);
        }
    })
}

export const deleteRecipePlan = async (userID, serverProps, recipePlans, setRecipePlans, Plan_ID) => {
    await QueryDatabase({
        user: userID,
        table: "recipe_plans",
        method: 1,
        filter: "",
        data: Plan_ID,
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        if (data) {
            const newRecipePlans = recipePlans.filter((element) => {
                return element.Plan_ID !== Number(Plan_ID)//Plan_ID comes in as a string
            })
            setRecipePlans(newRecipePlans);
        }
    })
}

/*highlightedIngredient:
Ingredient_ID,
Ingredient_Name,
Ingredient_Quantity,
Item_ID,
Recipe_ID,
Recipe_Ingredient_ID,
Recipe_Name

listIngredient:
Ingredient_ID,
Ingredient_Date,
Ingredient_Frozen,
Ingredient_Name,
Ingredient_Quantity
Plan_Date,//should be null
Plan_ID,//should be null
Recipe_ID, should be null
Recipe_Ingredient_ID, should be null
Recipe_Name should be null
*/
export const handlePair = async (serverProps, userID, recipePlans, setRecipePlans, ingredientsArray, setIngredientsArray, highlightedIngredient, listIngredient) => {
    const remainingQuantity = listIngredient.Ingredient_Quantity - highlightedIngredient.Ingredient_Quantity;
    await QueryDatabase({
        user: userID,
        table: "ingredients",
        method: 5,
        filter: "",
        data: {
            List_Ingredient: {
                ...listIngredient,
                Ingredient_Quantity: remainingQuantity,
                Ingredient_Date: listIngredient.Ingredient_Date.toLocaleDateString({
                    year: "numeric",
                    month: "numeric",
                    day: "numeric"
                }).split("/").reverse().join('-')//convert date into something mysql can process
            },
            Planned_Ingredient: highlightedIngredient
        },
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        if (data.affectedRows === 1) {
            const newIngredientsArray = ingredientsArray.map((ingredient) => {
                if (ingredient.Ingredient_ID === listIngredient.Ingredient_ID) {//find the source ingredient
                    if (remainingQuantity === 0) {//if all or it's used up, add in the Plan_ID
                        return {
                            ...ingredient,
                            Plan_ID: highlightedIngredient.Plan_ID
                        }}
                    else//if there's some remaining, reduce the quantity to the remaining amount
                        return {
                            ...ingredient,
                            Ingredient_Quantity: remainingQuantity
                        }
                }
                else
                    return ingredient
            });
            if (data.insertId) {//if we get an insert id back (which means remaining quantity is > 0). 
                                //Insert id CANNOT be 0 (this function requires at least 1 ingredient in the database), so if 0 is returned it's still an invalid value.
                newIngredientsArray.push({//add the newly created ingredient to the array
                    ...highlightedIngredient,
                    Ingredient_ID: data.insertId,
                    Ingredient_Date: new Date(listIngredient.Ingredient_Date),
                    Ingredient_Frozen: new Date(listIngredient.Ingredient_Frozen),
                    Ingredient_Source: listIngredient.Ingredient_ID
                })
            }
            setIngredientsArray(newIngredientsArray)
            
            const newRecipePlans = recipePlans.map((element) => {
                if (element.Plan_ID === highlightedIngredient.Plan_ID) {
                    return {
                        ...element,
                        Recipe_Ingredients: element.Recipe_Ingredients.map((recipeIngredient) => {
                            if (recipeIngredient.Recipe_Ingredient_ID === highlightedIngredient.Recipe_Ingredient_ID) {
                                return {
                                    ...recipeIngredient,
                                    Ingredient_ID: data.insertId || listIngredient.Ingredient_ID//uses listIngredient.Ingredient_ID if data.insertId is 0 or falsy
                                }
                            }
                            else
                                return recipeIngredient;
                        })
                    }
                }
                else
                    return element
            })
            
            setRecipePlans(newRecipePlans)
        }
    })
}

/**
 * recipe://is in fact a plan in a terrible disguise
 * Plan_Date,
 * Plan_ID,
 * Recipe_ID,
 * Recipe_Ingredients,
 * Recipe_Name
 */
export const handleShopPlan = async (serverProps, userID, recipePlans, setRecipePlans, shoppingList, setShoppingList, highlightedIngredient, recipe) => {
    await QueryDatabase({
        user: userID,
        table: "shopping_list",
        method: 0,
        filter: "",
        data: {
            Item_Name: highlightedIngredient.Ingredient_Name,
            Item_Quantity: highlightedIngredient.Ingredient_Quantity,
            Item_Recipe_Plan: recipe.Plan_ID,
            Item_Recipe_Plan_Ingredient: highlightedIngredient.Recipe_Ingredient_ID
        },
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        if (data.insertId >= 0) {
            const newRecipePlans = recipePlans.map((plan) => {
                if (plan.Plan_ID === recipe.Plan_ID)
                    return {
                        ...plan,
                        Recipe_Ingredients: recipe.Recipe_Ingredients.map((element) => {
                            if (highlightedIngredient.Recipe_Ingredient_ID === element.Recipe_Ingredient_ID) {
                                return {
                                    ...element,
                                    Item_ID: data.insertId
                                };
                            }
                            else
                                return element;
                        })
                    };
                else
                    return plan;
            })
            setRecipePlans(newRecipePlans)
            const newShoppingList = [...shoppingList, {
                Item_ID: data.insertId,
                Item_Name: highlightedIngredient.Ingredient_Name,
                Item_Quantity: highlightedIngredient.Ingredient_Quantity,
                Item_Recipe_Plan: recipe.Plan_ID,
                Plan_Date: recipe.Plan_Date,
                Recipe_Name: recipe.Recipe_Name,
                Item_Recipe_Plan_Ingredient: highlightedIngredient.Recipe_Ingredient_ID
            }]
            setShoppingList(newShoppingList)
        }
    })
} 